import { combineReducers } from '@reduxjs/toolkit';
import selection from './DeviceSelectionSlice';

const reducer = combineReducers({
	selection
});

export default reducer;
